/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';

import type { CommonResponseWrapper } from 'hems';

import type { NoticeSearchOptions, NoticeListItem } from 'hems/notice';

export default class NoticeService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 공지사항 상세 조회 */
  getNoticeInfo = async (noticeId: number): Promise<NoticeListItem> => {
    const { data } = await this.get<CommonResponseWrapper<NoticeListItem>>(
      apiWrapper.managerApi('/managements/notice'),
      { noticeId }
    );

    return data;
  };

  /** 공지사항 목록 조회 */
  getNoticeList = async (params: NoticeSearchOptions): Promise<NoticeListItem[]> => {
    const { data } = await this.get<CommonResponseWrapper<NoticeListItem[]>>(
      apiWrapper.managerApi('/managements/notice/list'),
      params
    );

    return data;
  };

  /** 공지사항 생성 */
  createNotice = async (noticeInfo: Omit<NoticeListItem, 'noticeId'>) => {
    const { data } = await this.post<CommonResponseWrapper<NoticeListItem>>(
      apiWrapper.managerApi('/managements/notice'),
      noticeInfo
    );

    return data;
  };

  /** 공지사항 삭제 */
  deleteNotice = async (noticeId: number): Promise<{ noticeId: number }> => {
    const { data } = await this.delete<CommonResponseWrapper<{ noticeId: number }>>(
      apiWrapper.managerApi('/managements/notice/delete'),
      undefined,
      { data: { noticeId } }
    );

    return data;
  };

  /** 공지사항 수정 */
  updateNotice = async (noticeInfo: NoticeListItem): Promise<{ noticeId: number }> => {
    const { data } = await this.put<CommonResponseWrapper<{ noticeId: number }>>(
      apiWrapper.managerApi('/managements/notice'),
      noticeInfo
    );

    return data;
  };
}
